import { findCountry } from "./index"

const BR = "BR"

/**
 * Detecta o país a partir de um locale BCP-47 (navigator.language), usando
 * Intl.Locale para resolver a região — cobre os 245 países do registry sem
 * precisar manter uma lista de idiomas por país.
 *
 * Duas regras de negócio da plataforma, preservadas do detector antigo
 * (que cobria só 12 países via lista manual de languageCodes):
 *
 * - Qualquer variante pt-* que não seja pt-BR nem pt cai em BR. Navegadores
 *   brasileiros configurados com pt-PT seriam detectados como Portugal, o
 *   que é quase sempre errado nesta plataforma. Usuários de Portugal podem
 *   selecionar o DDI manualmente.
 * - Locale vazio, inválido, ou cuja região não exista no registry cai em BR.
 */
export const detectCountryFromLocale = (locale: string): string => {
  if (!locale) return BR

  const normalized = locale.toLowerCase()
  if (normalized.startsWith("pt") && normalized !== "pt-br" && normalized !== "pt") {
    return BR
  }

  try {
    const region = new Intl.Locale(locale).maximize().region
    if (region && findCountry(region)) return region
  } catch {
    // locale malformado — cai no fallback abaixo
  }

  return BR
}
